<app-patient-info [heading]="Item"></app-patient-info>

<div class="card grid col-12 ml-0 mb-3"
     style="display: flex; background-color: white">
    <div class="">
        <h5 class="mt-3 pl-3 pr-0"><strong style="font-size: 1.17rem;">Order Type:</strong></h5>
    </div>

    <div class="col-12 md:col-4" style="margin-top: -6px">


        <p-multiSelect [options]="orderclassList"
                       optionLabel="classDescription"
                       optionValue="orderClassID"
                       class="p-fluid"
                       [formControl]="orderclass" name="orderclass"></p-multiSelect>

    </div>
</div>

<div class="">


    <p-table *ngIf="orders" #dt
             [responsive]="true"
             [columns]="selectedColumns"
             [value]="ordersObservable | async"
             selectionMode="single"
             dataKey="orderID"
             [resetPageOnSort]="false"
             [lazy]="false"
             [rows]="rows"
             [paginator]="showRecords"
             (sortFunction)="customSort($event, 1)"
             [customSort]="true" [globalFilterFields]="['enDate','class','description','status','orderedBy']">

        <ng-template pTemplate="caption">
            <!--<div class="col-12">
            <span class=" p-float-label">
                <input id="lastName" [(ngModel)]="lastName" type="text" pInputText autocomplete="off">
                <label for="lastName">Last Name</label>
            </span>
            </div>-->
            <div class="formgroup-inline col-12 pb-0">
                <div class="field pt-1">
                    <p-multiSelect [options]="cols"
                                   [(ngModel)]="selectedColumns"
                                   optionLabel="header"
                                   contenteditable="false"
                                   [showToggleAll]="true"
                                   selectedItemsLabel="{0} columns selected"
                                   [style]="{ minWidth: '200px' }"
                                   placeholder="Choose Columns">
                    </p-multiSelect>
                </div>



                <div class="field col-5 pb-0 pt-1 p-input-icon-right">
                    <label htmlfor="txtProblemSerach" class="p-sr-only">Enter your search</label>
                    <i class="pi"
                       (click)="startListening()"
                       title="Search by voice"
                       id="voiceIconId"
                       style="color: #4285f4; cursor: pointer; transition: color 0.3s ease"
                       [ngClass]="{
           'active-icon': isListening,
           'inactive-icon': !isListening,
         }"
                       *ngIf="false">🎤</i>
                    <input pinputtext="" #searchText
                           type="text" #serachBox
                           placeholder="Enter your search"
                           class="text-base text-color p-2 w-12"
                           style="width: auto; height: 37px" />
                </div>
                <div class="pb-0 pt-1 BH">
                    &nbsp;
                    <button pButton
                            type="button"
                            icon="pi pi-search"
                            (click)="applyGlobalFilter(searchText.value)"
                            label="Search"
                            class="p-button-plain"></button>
                    &nbsp;<p-button label="Clear"
                                    (click)="resetTables();clearSearchText(searchText)"
                                    severity="secondary"
                                    icon="pi pi-refresh"></p-button>&nbsp;
                    <button pButton
                            type="button"
                            icon="pi pi-print"
                            label="Print"
                            class="p-button-plain"
                            (click)="printOrders()"
                            title="Print Orders"
                            *ngIf="setPrintFlag"></button>&nbsp;
                </div>
            </div>



        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr *ngIf="showRecords == true">
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body"
                     let-rowData
                     let-columns="columns"
                     let-i="rowIndex">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns">
                    {{ formatdatetime(rowData[col.field], col.header) }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <div class="w-12 bg-white">
                <div class="" style="text-align: center">
                    <img _ngcontent-ng-c683320295=""
                         class="profile-image"
                         style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                         src="assets/imagesNew/table_error.png" />
                </div>
                <hr style="margin-bottom: 0.5rem" />
                <div class=""
                     style="text-align: center; font-size: larger; color: #1d428f">
                    <i>No records found</i>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <span *ngIf="state.totalRecords > pageSize">
                Showing {{ state.page * state.rows + 1 }} to
                {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
            </span>
        </ng-template>
    </p-table>
</div>


<!-- Print functionality  for Orders List -->

<div class="panel table-responsive" id="PrintOrders_List" style="display: none">
    <div style=" display: flex; background-color: #ffffff;   margin-bottom: 1.5%;  padding: 0.5%;">
        <div style="display: flex; justify-content: left; align-items: center; width: 50%;">
            <span>
                <strong>Order</strong> :&nbsp; {{orderclass.value}}




            </span>
        </div>
        <div style="display: flex; justify-content: right;align-items: center; width: 50%;">
            <span><strong>{{patientFullName}}</strong></span>
        </div>
    </div>

    <div style="display: flex;  align-items: center; justify-content: center;  margin: 0% 0% 0% 0%;">

        <!--<table style="width: 100%; border-collapse: collapse; border: 1px solid grey"
               id="Order_print_table_tbody">
            <thead style=" background-color: #142066; border: 0px solid #808080;color: snow;">
                <tr>
                    <th *ngFor="let col of selectedColumns"
                        style="border: 1px solid #808080; text-align: left">
                        {{ col.header }}
                    </th>
                </tr>
            </thead>
            <tbody id="Orders_print_table_tbody">
                <tr *ngFor="let item of orders?.data"
                    style="border: 1px solid #808080">
                    <td *ngFor="let col of selectedColumns" style=" text-align: left; border: 1px solid #808080; padding: 0.5% 0% 0.5% 0%;">
                        {{ formatdatetime(item[col.field],col.header) }}
                    </td>
                </tr>
            </tbody>
        </table>-->



        <p-table *ngIf="orders" #dt1 [responsive]="true" [columns]="selectedColumns" [value]="ordersObservable | async" selectionMode="single" dataKey="orderID" [resetPageOnSort]="false" [lazy]="false" [rows]="rows"
                 [globalFilterFields]="['enDate','class','description','status','orderedBy']" [customSort]="true" style="width: 100% !important; border-collapse: collapse !important; border: 1px solid grey !important; table-layout: auto !important;">
            <ng-template pTemplate="header" let-columns>
                <thead style=" background-color: #142066; border: 0px solid #808080;color: snow;">
                    <tr *ngIf="showRecords == true">
                        <th *ngFor="let col of columns" style="border: 1px solid #808080; text-align: left">
                            {{ col.header }}

                        </th>
                    </tr>
                </thead>
            </ng-template>
            <!--<ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
        <tr style="border: 1px solid #808080">
            <td *ngFor="let col of columns" style="text-align: left; border: 0px solid #808080; padding: 0.5% 0% 0.5% 0%;">
                {{ formatdatetime(rowData[col.field], col.header) }}
            </td>
        </tr>
    </ng-template>-->


            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                <tr [attr.style]="'background-color: ' + (i % 2 === 0 ? '#f2f2f2' : '#e6e6e6') + ' !important; border: 1px solid #808080 !important;'">
                    <td *ngFor="let col of columns"
                        style="text-align: left; border: 0px solid #808080 !important; padding: 0.5% 0% 0.5% 0% !important;">
                        {{ formatdatetime(rowData[col.field], col.header) }}
                    </td>
                </tr>
            </ng-template>


        </p-table>

    </div>
    <div *ngIf="orders?.data.length == 0" class="alert alert-warning" role="alert" style="text-align: center">
        <span class="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"></span>
        <span class="sr-only">Error:</span>
        No orders found.!
    </div>
</div>
